import { Injectable, OnInit } from '@angular/core';
import { UserStore } from '../store/user.store';
import { Roles, hasHrRole } from '../constant/roles';


@Injectable({
  providedIn: 'root'
})
export class RoleService implements OnInit {

  public roles: Roles;

  constructor(private userStore: UserStore) {
  }

  ngOnInit(): void {
    console.log("ngOnInit RoleService");
  }

  getRoleAdminCode(): string{
    return Roles.ADMINISTRATOR;
  }

  getRoleDirezioneCode(): string{
    return Roles.DIREZIONE;
  }

  getRoleHrCode(): string{
    return Roles.HR;
  }

  getRoleUserCode(): string{
    return Roles.USER;
  }

  hasRole(role: Roles): boolean {

    if (this.userStore.userLogged?.roles.includes(role))
      return true;
    else
      return false;
  }

  hasAdmin(): boolean {
    if (!this.userStore.userLogged) return false;
    const roles = (this.userStore.userLogged.roles || []).map(r => (r || '').toUpperCase());
    const funzione = (this.userStore.userLogged.funzione || '').toUpperCase();
    return roles.includes(Roles.ADMINISTRATOR) || roles.includes('ADMIN') || roles.includes('ADMINISTRATOR') || funzione === 'ADMIN';
  }

  hasHRandAdmin(): boolean {
    if (!this.userStore.userLogged?.roles) return false;
    const roles = this.userStore.userLogged.roles.map(r => (r || '').toUpperCase());
    return (roles.includes(Roles.HR) || roles.includes('HC')) && 
           (roles.includes(Roles.ADMINISTRATOR) || roles.includes('ADMIN'));
  }

  hasHRorAdmin(): boolean {
    if (!this.userStore.userLogged) return false;
    const roles = (this.userStore.userLogged.roles || []).map(r => (r || '').toUpperCase());
    const funzione = (this.userStore.userLogged.funzione || '').toUpperCase();
    return roles.includes(Roles.HR) || 
           roles.includes(Roles.HC) || 
           roles.includes('HC') || 
           roles.includes(Roles.ADMINISTRATOR) || 
           roles.includes('ADMIN') ||
           roles.includes('ADMINISTRATOR') ||
           funzione === 'HR' || 
           funzione === 'HC' || 
           funzione === 'ADMIN';
  }

  hasHR(): boolean {
    if (!this.userStore.userLogged) return false;
    const roles = (this.userStore.userLogged.roles || []).map(r => (r || '').toUpperCase());
    const funzione = (this.userStore.userLogged.funzione || '').toUpperCase();
    return roles.includes(Roles.HR) || roles.includes(Roles.HC) || roles.includes('HC') || funzione === 'HR' || funzione === 'HC';
  }

  hasJIRA(): boolean {

    if (this.userStore.userLogged?.roles.includes(Roles.JIRA))
      return true;
    else
      return false;
  }

  getRoleManagerCode(): string {
    return Roles.MANAGER;
  }

  hasManager(): boolean {
    if (this.userStore.userLogged?.roles.includes(Roles.MANAGER))
      return true;
    else
      return false;
  }

  hasHRorManager(): boolean {
    if (hasHrRole(this.userStore.userLogged?.roles) || this.userStore.userLogged?.roles?.includes(Roles.MANAGER))
      return true;
    else
      return false;
  }

}
